// extracted by mini-css-extract-plugin
module.exports = {"goBack":"SubpageLayout_goBack_6Cnpc","backIcon":"SubpageLayout_backIcon_7f6wY","content":"SubpageLayout_content_2UNPp"};